import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import * as XLSX from "xlsx";
import dayjs from "dayjs";

// Utility function to generate table headers
const generateTableHeaders = (columns) => {
  return columns
    ?.map((col) => col.title)
    .filter((header) => header !== "Actions" && header !== "Sl No");
};

// Resolve company and branch
const getCompanyAndBranch = (data, companyInfolist) => {
  console.log("Data passed to PDF:", data);
  console.log("Company info passed to PDF:", companyInfolist);

  const branchName =
    data?.[0]?.branch?.name || "Branch Name Not Available";

  let companyName = "Company Name Not Available";

  if (Array.isArray(companyInfolist) && companyInfolist.length > 0) {
    const firstCompany = companyInfolist.find(c => c?.name);
    if (firstCompany) companyName = firstCompany.name;
  } else if (companyInfolist && typeof companyInfolist === "object") {
    companyName = companyInfolist.name || companyName;
  }

  console.log("Resolved Company Name:", companyName, "Branch Name:", branchName);
  return { companyName, branchName };
};


// Utility function to generate table body rows
const generateTableBody = (data, tableHeaders, fieldMapping,currfmt) => {
  return data?.map((item) => {
    return tableHeaders?.map((header) => {
      const field = fieldMapping[header];
      let value = item[field];

      if (field === "product") {
        value = item?.product?.name;
      }
      if (field === "category") {
        value = item?.category?.name;
      }
      if (field === "type") {
        value = item?.type?.name;
      }
      if (field === "ledger") {
        value = item?.ledger?.name;
      }
      if (field === "date") {
        value = dayjs(item?.date).format("DD-MM-YYYY");
      }
      //HOURLY REPORTS
      if (field === "billTime") {
        value = dayjs(item?.billTime).format("DD-MM-YYYY HH:mm");
      }
      if (field === "stockvalue") {
        value = item.wAvrgCost * item.totalCurStock; // Get unit name
      }
      
      if (typeof value === "number" && currfmt !== undefined) {
        value = value.toFixed(currfmt);
      }
      return value?? "";
    });
  });
};

// Excel Export
// export const exportExcel = (getActiveTabData, footerTotals, title) => {
//   const { data, columns, fieldMapping, filename,Rname,currfmt } = getActiveTabData();
//   const tableHeaders = generateTableHeaders(columns);
//   const tableBody = generateTableBody(data, tableHeaders, fieldMapping,currfmt);
//   const footerRow = footerTotals
//     ? tableHeaders.map((header) => footerTotals[fieldMapping[header]] || "")
//     : null;
//   const fullTable =
//     footerRow && footerRow.some((cell) => cell)
//       ? [...tableBody, footerRow]
//       : tableBody;
//   const worksheet = XLSX.utils.aoa_to_sheet([tableHeaders, ...fullTable]);
//   //const worksheet = XLSX.utils.aoa_to_sheet([tableHeaders, ...tableBody]);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

//   XLSX.writeFile(workbook, `${Rname}.xlsx`);
// };

export const exportExcel = (getActiveTabData, footerTotals, companyInfolist) => {
  const { data, columns, fieldMapping, Rname, currfmt } = getActiveTabData();
  const { companyName, branchName } = getCompanyAndBranch(data, companyInfolist);

  const tableHeaders = generateTableHeaders(columns);
  const tableBody = generateTableBody(data, tableHeaders, fieldMapping, currfmt);

  const footerRow = footerTotals
    ? tableHeaders.map((header) => footerTotals[fieldMapping[header]] || "")
    : null;

  const fullTable =
    footerRow && footerRow.some((cell) => cell)
      ? [...tableBody, footerRow]
      : tableBody;

  // ✅ Add company & branch info as first rows
  const headerInfo = [
    [`Company: ${companyName}`],
    [`Branch: ${branchName}`],
    [Rname],
    [], // blank line
  ];

  const worksheet = XLSX.utils.aoa_to_sheet([
    ...headerInfo,
    tableHeaders,
    ...fullTable,
  ]);

  const workbook = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

  XLSX.writeFile(workbook, `${Rname}.xlsx`);
};


// Printable format
export const printReport = (getActiveTabData, footerTotals, companyInfolist) => {
  const { data, columns, fieldMapping, Rname, currfmt } = getActiveTabData();
  const { companyName, branchName } = getCompanyAndBranch(data, companyInfolist);

  const printWindow = window.open("", "_blank");

  // Prepare the document for printing
  printWindow.document.write(`<html><head><title>${Rname}</title>`);
  printWindow.document.write("<style>");
  printWindow.document.write(`
        table {
            width: 100%;
            border-collapse: collapse;
        }
        th, td {
            border: 1px solid black;
            padding: 8px;
            text-align: left;
        }
        th {
            background-color: #f2f2f2;
        }
    `);
  
  printWindow.document.write("</style></head><body>");

  // ✅ Add company & branch above the title
    printWindow.document.write(`<h1>${Rname}</h1>`);
  printWindow.document.write(`<h3>Company: ${companyName}</h3>`);
  printWindow.document.write(`<h3>Branch: ${branchName}</h3>`);



  const tableHeaders = generateTableHeaders(columns);
  let tableHTML = "<table><thead><tr>";
  tableHeaders.forEach((header) => {
    tableHTML += `<th>${header}</th>`;
  });
  tableHTML += "</tr></thead><tbody>";

  const tableBody = generateTableBody(data, tableHeaders, fieldMapping,currfmt);
  tableBody.forEach((row) => {
    tableHTML += "<tr>";
    row.forEach((cell) => {
      tableHTML += `<td>${cell !== undefined ? cell : ""}</td>`;
    });
    tableHTML += "</tr>";
  });
  //footertotals
  if (footerTotals && Object.values(footerTotals).some((value) => value)) {
    const footerRowHTML = tableHeaders
      .map((header) => `<td>${footerTotals[fieldMapping[header]] || ""}</td>`)
      .join("");
    tableHTML += `<tr>${footerRowHTML}</tr>`;
  }
  //
  tableHTML += "</tbody></table>";

  printWindow.document.write(tableHTML);
  printWindow.document.write("</body></html>");

  printWindow.document.close();
  printWindow.print();
};




export const exportPDF = (getActiveTabData, footerTotals, companyInfolist) => {
  const { data, columns, fieldMapping, Rname, currfmt } = getActiveTabData();
  const { companyName, branchName } = getCompanyAndBranch(data, companyInfolist);

  const orientation = columns?.length > 9 ? "landscape" : "portrait";
  const doc = new jsPDF({ orientation });

  doc.setFontSize(16);
  doc.text(`${Rname}`, 14, 20);

  doc.setFontSize(10);
  doc.text(`Company: ${companyName}`, 14, 29);
  doc.text(`Branch: ${branchName}`, 14, 38);

  const tableHeaders = generateTableHeaders(columns);
  const tableBody = generateTableBody(data, tableHeaders, fieldMapping, currfmt);

  const footerRow =
    footerTotals &&
    tableHeaders.some((header) => footerTotals[fieldMapping[header]])
      ? tableHeaders.map((header) => footerTotals[fieldMapping[header]] || "")
      : null;

  autoTable(doc, {
    head: [tableHeaders],
    body: tableBody,
    ...(footerRow ? { foot: [footerRow] } : {}),
    theme: "grid",
    styles: { fontSize: 10, cellPadding: 3 },
    headStyles: { fillColor: [63, 81, 181] },
    startY: 45,
  });

  doc.save(`${Rname}.pdf`);
};

// Function to get active tab data


// import { jsPDF } from "jspdf";
// import autoTable from "jspdf-autotable";
// import * as XLSX from "xlsx";
// import dayjs from "dayjs";

// // Utility function to generate table headers
// const generateTableHeaders = (columns) => {
//   return columns
//     ?.map((col) => col.title)
//     .filter((header) => header !== "Actions" && header !== "Sl No");
// };

// // Resolve company and branch
// const getCompanyAndBranch = (companyInfolist, branch) => {
//   const company =
//     Array.isArray(companyInfolist) && companyInfolist.length > 0
//       ? companyInfolist[0]
//       : companyInfolist;

//   const companyName = company?.name || "";
//   const branchName = branch?.name || "";
//   return { companyName, branchName };
// };

// // Utility function to generate table body rows
// const generateTableBody = (data, tableHeaders, fieldMapping, currfmt) => {
//   return data?.map((item) => {
//     return tableHeaders?.map((header) => {
//       const field = fieldMapping[header];
//       let value = item[field];

//       if (field === "product") {
//         value = item?.product?.name;
//       }
//       if (field === "category") {
//         value = item?.category?.name;
//       }
//       if (field === "type") {
//         value = item?.type?.name;
//       }
//       if (field === "ledger") {
//         value = item?.ledger?.name;
//       }
//       if (field === "date") {
//         value = dayjs(item?.date).format("DD-MM-YYYY");
//       }
//       // HOURLY REPORTS
//       if (field === "billTime") {
//         value = dayjs(item?.billTime).format("DD-MM-YYYY HH:mm");
//       }
//       if (field === "stockvalue") {
//         value = item.wAvrgCost * item.totalCurStock;
//       }

//       if (typeof value === "number" && currfmt !== undefined) {
//         value = value.toFixed(currfmt);
//       }
//       return value ?? "";
//     });
//   });
// };

// // Excel Export
// export const exportExcel = (getActiveTabData, footerTotals, title) => {
//   const { data, columns, fieldMapping, Rname, currfmt } = getActiveTabData();
//   const tableHeaders = generateTableHeaders(columns);
//   const tableBody = generateTableBody(data, tableHeaders, fieldMapping, currfmt);
//   const footerRow = footerTotals
//     ? tableHeaders.map((header) => footerTotals[fieldMapping[header]] || "")
//     : null;
//   const fullTable =
//     footerRow && footerRow.some((cell) => cell)
//       ? [...tableBody, footerRow]
//       : tableBody;

//   const worksheet = XLSX.utils.aoa_to_sheet([tableHeaders, ...fullTable]);
//   const workbook = XLSX.utils.book_new();
//   XLSX.utils.book_append_sheet(workbook, worksheet, "Report");

//   XLSX.writeFile(workbook, `${Rname}.xlsx`);
// };

// // Printable format
// export const printReport = (getActiveTabData, footerTotals, title) => {
//   const { data, columns, fieldMapping, Rname, currfmt } = getActiveTabData();

//   const printWindow = window.open("", "_blank");
//   printWindow.document.write(`<html><head><title>${Rname}</title>`);
//   printWindow.document.write("<style>");
//   printWindow.document.write(`
//         table { width: 100%; border-collapse: collapse; }
//         th, td { border: 1px solid black; padding: 8px; text-align: left; }
//         th { background-color: #f2f2f2; }
//     `);
//   printWindow.document.write("</style></head><body>");
//   printWindow.document.write(`<h1>${Rname}</h1>`);

//   const tableHeaders = generateTableHeaders(columns);
//   let tableHTML = "<table><thead><tr>";
//   tableHeaders.forEach((header) => {
//     tableHTML += `<th>${header}</th>`;
//   });
//   tableHTML += "</tr></thead><tbody>";

//   const tableBody = generateTableBody(data, tableHeaders, fieldMapping, currfmt);
//   tableBody.forEach((row) => {
//     tableHTML += "<tr>";
//     row.forEach((cell) => {
//       tableHTML += `<td>${cell !== undefined ? cell : ""}</td>`;
//     });
//     tableHTML += "</tr>";
//   });

//   // footertotals
//   if (footerTotals && Object.values(footerTotals).some((value) => value)) {
//     const footerRowHTML = tableHeaders
//       .map((header) => `<td>${footerTotals[fieldMapping[header]] || ""}</td>`)
//       .join("");
//     tableHTML += `<tr>${footerRowHTML}</tr>`;
//   }

//   tableHTML += "</tbody></table>";
//   printWindow.document.write(tableHTML);
//   printWindow.document.write("</body></html>");
//   printWindow.document.close();
//   printWindow.print();
// };

// // PDF Export
// export const exportPDF = (getActiveTabData, footerTotals, Rname, companyInfolist, branch) => {
//   const { data, columns, fieldMapping, currfmt } = getActiveTabData();
//   const { companyName, branchName } = getCompanyAndBranch(companyInfolist, branch);

//   const orientation = columns?.length > 9 ? "landscape" : "portrait";
//   const doc = new jsPDF({ orientation });

//   doc.setFontSize(16);
//   doc.text(`${Rname}`, 14, 20);

//   doc.setFontSize(10);
//   doc.text(`Company: ${companyName}`, 14, 29);
//   doc.text(`Branch: ${branchName}`, 14, 38);

//   const tableHeaders = generateTableHeaders(columns);
//   const tableBody = generateTableBody(data, tableHeaders, fieldMapping, currfmt);

//   const footerRow =
//     footerTotals &&
//     tableHeaders.some((header) => footerTotals[fieldMapping[header]])
//       ? tableHeaders.map((header) => footerTotals[fieldMapping[header]] || "")
//       : null;

//   autoTable(doc, {
//     head: [tableHeaders],
//     body: tableBody,
//     ...(footerRow ? { foot: [footerRow] } : {}),
//     theme: "grid",
//     styles: { fontSize: 10, cellPadding: 3 },
//     headStyles: { fillColor: [63, 81, 181] },
//     startY: 45,
//   });

//   doc.save(`${Rname}.pdf`);
// };
